var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.254 2.87683C12.0047 2.7735 11.718 2.83083 11.5274 3.0215C10.6847 3.8635 9.31336 3.86417 8.47003 3.0215C7.1067 1.6595 4.89003 1.6595 3.52736 3.0215C3.40203 3.14617 3.33203 3.31617 3.33203 3.49283V12.1595C3.33203 12.5275 3.63003 12.8262 3.9987 12.8262C4.36736 12.8262 4.66536 12.5275 4.66536 12.1595V9.12417C5.5127 8.4595 6.74603 8.51683 7.52736 9.2975C8.8907 10.6595 11.108 10.6595 12.47 9.2975C12.5954 9.17217 12.6654 9.00283 12.6654 8.82617V3.49283C12.6654 3.22283 12.5027 2.98017 12.254 2.87683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteFlag);
export default __webpack_public_path__ + "static/media/vote-flag.f47b2209041bcdfd19f11bfd7709c698.svg";
export { ForwardRef as ReactComponent };